<script lang="ts">
	import ForgotPasswordForm from '$lib/components/Form/ForgotPasswordForm.svelte';
	import { classes } from '$lib/utils';
	import { getTranslate } from '@tolgee/svelte';

	const { t } = getTranslate();

	export let additionalClass = '';
</script>

<div class={classes(additionalClass, 'flex flex-col items-center justify-center')}>
	<div class="w-full flex flex-col max-w-[400px]">
		<ForgotPasswordForm on:success />
	</div>
</div>
